import React from 'react';
import { Button, Result } from 'antd';

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

function isChunkLoadError(error: Error): boolean {
  const msg = error.message || '';
  return (
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Loading chunk [\d]+ failed/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    error.name === 'ChunkLoadError'
  );
}

/**
 * Catches failed dynamic imports (e.g. stale chunk after deploy) and offers a reload.
 */
export default class ChunkLoadErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  private handleReload = () => {
    window.location.reload();
  };

  private handleRetry = () => {
    this.setState({ error: null });
  };

  render() {
    const { error } = this.state;
    if (!error) {
      return this.props.children;
    }

    const chunkError = isChunkLoadError(error);

    return (
      <Result
        status={chunkError ? 'warning' : 'error'}
        title={chunkError ? '页面资源已更新' : '页面加载失败'}
        subTitle={
          chunkError
            ? '检测到新版本已发布，请刷新页面以加载最新资源。'
            : error.message || '请稍后重试或刷新页面。'
        }
        extra={
          <Button type="primary" onClick={chunkError ? this.handleReload : this.handleRetry}>
            {chunkError ? '刷新页面' : '重试'}
          </Button>
        }
      />
    );
  }
}
